import VenetianMask from "./VenetianMask";

export * from "./Axe";
export * from "./Backpake";
export * from "./Beaker";
export * from "./Clover";
export * from "./Club";
export * from "./Coins";
export * from "./Dice1";
export * from "./Dice2";
export * from "./Dice3";
export * from "./Dice4";
export * from "./Dice5";
export * from "./Dice6";
export * from "./Dices";
export * from "./Droplet";
export * from "./Feather";
export * from "./Flame";
export * from "./FlameKinding";
export * from "./FlaskConical";
export * from "./FlaskConicalOff";
export * from "./FlaskRound";
export * from "./Flower";
export * from "./Ghost";
export * from "./Goal";
export * from "./HourGlass";
export * from "./Medal";
export * from "./Memorystick";
export * from "./MileSton";
export * from "./Mountain";
export * from "./Pickaxe";
export * from "./Scane";
export * from "./Scrolltext";
export * from "./Shapes";
export * from "./Shovel";
export * from "./SingPost";
export * from "./SingPostBig";
export * from "./Skull";
export * from "./Spade";
export * from "./Sprout";
export * from "./Sword";
export * from "./Tally1";
export * from "./Tally2";
export * from "./Tally3";
export * from "./Tally4";
export * from "./Tally5";
export * from "./Target";
export * from "./Trophy";
export * from "./VenetianMask";

export const Gaming = {
  VenetianMask,
};
